import { SxProps, Theme } from '@mui/material';

const nameRow: SxProps<Theme> = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10px',
  mb: 1
};

const name: SxProps<Theme> = {
  fontSize: '30px',
  lineHeight: '38px',
  fontWeight: 400,
  color: 'customGrey.dark'
};

const metaRow: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 1,
  '& .MuiTypography-root': {
    fontSize: '16px',
    lineHeight: '26px'
  }
};

const metaItem: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  '& .MuiSvgIcon-root': {
    fontSize: '20px'
  }
};

const separator: SxProps<Theme> = {
  color: 'customGrey.dark'
};

export const conversationDetailsHeaderSx = {
  nameRow,
  name,
  metaRow,
  metaItem,
  separator
};
